import '@take-2/views/movie/layouts/partials/_movieShowtimes.js';
import '@take-2/views/desktop/shared/_rottenTomatoesRating.js';
